<template>
    <div class="booking-summary-callout policy-callout">
        <strong class="callout-title">
            <svg version="1.1" viewBox="0 0 14 16">
                <path fill-rule="evenodd" d="M7 2.3c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7A5.71 5.71 0 0 1 1.3 8c0-3.14 2.56-5.7 5.7-5.7zM7 1C3.14 1 0 4.14 0 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm1 3H6v5h2V4zm0 6H6v2h2v-2z"></path>
            </svg>
            <span>
                Booking Policy
            </span>
        </strong> 
        <span v-html="policy"></span>
        <fieldset>
          <input-checkbox
            :label="policyMessage"
            ref="checkbox"
            required="true"
            v-on:change="toggle">
          </input-checkbox>

          <div class="input__validation-error-msg" v-if="validationErr">
            {{ validationErrMsg }}
          </div>
        </fieldset>
    </div>
</template>

<script>
  import inputCheckbox from './inputCheckbox'

  export default {
    name: 'bookingPolicy',
    props: [
      'policy',
      'value'
    ],
    components: {
      inputCheckbox
    },
    data () {
      return {
        checked: this.value,
        policyMessage: 'I confirm I have read this booking policy',
        validationErrMsg: 'Please read the booking policy',
        validationErr: false
      }
    },
    methods: {
      hideValidationMessage () {
        this.validationErr = false
      },
      showValidationMessage () {
        this.validationErr = true
      },
      passesValidation () {
        if (!this.checked) {
          this.showValidationMessage()
        }

        return this.checked
      },
      toggle (state) {
        this.checked = state
      }
    },
    watch: {
      checked: function () {
        this.hideValidationMessage()
        this.$emit('input', this.checked)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// bookingPolicy.vue?1ad48146